/* ================================================== */
/* FUNCTIONS
/* ================================================== */
function scroll_page() {

  // --- navigation --- //
  var navOuterHeight = 58;

  if ($(window).scrollTop() >= navOuterHeight && !$('body').hasClass('mobile')) {
    $('body').addClass('nav--fixed');
  } else {
    $('body').removeClass('nav--fixed');
  }

}

/* ================================================== */
/* DOCUMENT READY
/* ================================================== */

$(document).ready(function(){
	var url = window.location.href;

  // --- modal --- //
  if (sessionStorage.getItem("modal") !== 'true') {
    $(".modal").removeClass('hidden');
    $('.modal__closeBtn').on('click', function(e){
      sessionStorage.setItem("modal", "true");
      $(".modal").fadeOut();
    });
  }  
  
  // --- Smooth scroll ---- //

  $('#layout--navigation a[href^="#"]').click(function(){
  	var the_id = $(this).attr("href");
  	$('html, body').animate({
  		scrollTop: $(the_id).offset().top - 20 - 80
  	}, 'slow');
  	return false;
  });

  // --- Mapbox ---- //

	L.mapbox.accessToken = 'pk.eyJ1IjoiZXZlcnl0aGluZ2lzZnVuIiwiYSI6IkVkalZJRUkifQ.i_Taxju9f5wO9aUyOF7Gyg';
	var map = L.mapbox.map('map')
      .setView([49.613832, 6.121680], 16);

	L.mapbox.styleLayer('mapbox://styles/everythingisfun/ciw3dq94300id2klkow40nyba').addTo(map);

	L.marker([49.613832, 6.121680], {
	    icon: L.mapbox.marker.icon({
	        'marker-size': 'medium',
	        'marker-symbol': 'circle',
	        'marker-color': '#a18224'
	    })
	}).addTo(map);

});



/* ================================================== */
/* SCROLL EVENT
/* ================================================== */

$(window).on('scroll resize orientationchange', function(){
  scroll_page();
});


/* ================================================== */
/* WINDOW RESIZE ORIENTATIONCHANGE
/* ================================================== */

$(window).on('resize orientationchange', function(){
  if ($(window).width() < 767) {
    $('body').addClass('mobile tablet');
  } else {
    $('body').removeClass('mobile tablet');
  }
});